import { UserManager, WebStorageStateStore, Log, User } from 'oidc-client';
import toasts from './modules/commonUtils/toasts';
import { IPermission } from './modules/onboarding/onboardingModels';
import { v4 as uuid4 } from 'uuid';
export const getMCDEnabled = (params: string) => {
  const MCDSSO = new URLSearchParams(params).get('mcd');
  return MCDSSO !== null && MCDSSO.toLowerCase() === 'true';
};
const hstName = window.location.href

const isMCDSSO = window.location.pathname.includes('mcd') || getMCDEnabled(window.location.search) || (window as any).ENV.MCD_INSTANCE || ((window as any).ENV.ADMIN_MCD_HOSTNAME !== '' ? hstName.includes((window as any).ENV.ADMIN_MCD_HOSTNAME) : false)

export class AuthService {
  public honForgeUserManager: UserManager;
  public honSSOUsermanager: UserManager;
  sessionTimer = 3600;
  BASE_URL = '';
  OFFERING = '';
  globalPermissions: IPermission[] = [];
  lastActiveTime: number = 0;
  isLicensePrivilegedUser: boolean = false;

  public get userManager(): UserManager {
    const isHonSSOLogin = localStorage.getItem('selectedLoginOption') === 'SSO';
    return isHonSSOLogin ? this.honSSOUsermanager : this.honForgeUserManager;
  }

  constructor(clientIds: string) {
    // tslint:disable-next-line:no-any
    const environmentVariables = (window as any).ENV;
    this.BASE_URL = environmentVariables.BASE_URL;

    this.OFFERING = environmentVariables.OFFERING;

    const AUTHORITY = environmentVariables.AUTHORITY;
    // const clientId = environmentVariables.AUTHORITY_CLIENT_ID;
    const clientId = clientIds;
    const tenantId = environmentVariables.TENANT_ID;
    this.lastActiveTime = new Date().getTime();
    /**
     * The known current self url, used for settings of callback and silent renew
     */
    const currentWebURL = window.location.origin + '/';
    const isHonSSOLogin = localStorage.getItem('selectedLoginOption') === 'SSO';
    /**
     * Build string of auth scopes for the APIs used requring auth
     */
    const authScopes = environmentVariables.API_SCOPES.join(' ');

    const settings = {
      automaticSilentRenew: true,
      silent_redirect_uri: `${currentWebURL}silent-renew.html`,
      authority: AUTHORITY,
      client_id: clientId,
      redirect_uri: `${currentWebURL}signin-callback.html`,
      post_logout_redirect_uri: `https://login.microsoftonline.com/${tenantId}/oauth2/logout?post_logout_redirect_uri=${currentWebURL}app/login-redirect`,
      response_type: 'code',
      scope: authScopes,
      filterProtocolClaims: true,
      loadUserInfo: true,
      userStore: new WebStorageStateStore({ store: window.sessionStorage })
    };

    this.honForgeUserManager = new UserManager(settings);

    const honSSOSettings = {
      automaticSilentRenew: true,
      silent_redirect_uri: `${currentWebURL}silent-renew.html`,
      authority: environmentVariables.AUTHORITY_HON_SSO,
      client_id: environmentVariables.AUTHORITY_CLIENT_ID_HON_SSO,
      redirect_uri: `${currentWebURL}signin-callback.html`,
      post_logout_redirect_uri: `https://login.microsoftonline.com/${tenantId}/oauth2/logout?post_logout_redirect_uri=${currentWebURL}app/login-redirect`,
      response_type: 'code',
      scope: environmentVariables.API_SCOPES_HON_SSO?.join(' '),
      filterProtocolClaims: true,
      loadUserInfo: true,
      metadata:{
        end_session_endpoint: environmentVariables.HON_SSO_END_SESSION_ENDPOINT,
        authorization_endpoint: environmentVariables.HON_SSO_AUTHORIZATION_ENDPOINT,
        token_endpoint: environmentVariables.HON_SSO_TOKEN_ENDPOINT,
        userinfo_endpoint: environmentVariables.HON_SSO_USERINFO_ENDPOINT,
      },
      userStore: new WebStorageStateStore({ store: window.sessionStorage })
    };

    this.honSSOUsermanager = new UserManager(honSSOSettings);

    Log.logger = console;
    Log.level = Log.INFO;

    // this.honForgeUserManager.events.addAccessTokenExpired(() => {
    //   if (!window.location.href.includes('signup')) {
    //     sessionStorage.setItem('POST_SIGNIN_LOCATION', window.location.href);
    //     // Only redirect if you're not at any of the signup urls
    //     const environmentVariables = (window as any).ENV;
    //     if (isMCDSSO) {
    //       return this.honForgeUserManager.signinRedirect(
    //         {
    //           extraQueryParams: {
    //             login_hint: environmentVariables.ADMIN_MCD_LOGIN_HINT
    //           },
    //         }
    //       ).catch(e =>
    //         toasts.error(
    //           'Login failed. This is likely a configuration problem, please contact support.'
    //         )
    //       );
    //     } else {
    //       return this.honForgeUserManager.signinRedirect().catch(e =>
    //         toasts.error(
    //           'Login failed. This is likely a configuration problem, please contact support.'
    //         )
    //       );;
    //     }
    //     //this.userManager.signinRedirect();
    //   }
    // });

    this.honSSOUsermanager.events.addAccessTokenExpired(() => {
      if (!window.location.href.includes('signup')) {
        sessionStorage.setItem('POST_SIGNIN_LOCATION', window.location.href);
        // Only redirect if you're not at any of the signup urls
        const environmentVariables = (window as any).ENV;
        if (isMCDSSO) {
          return this.honSSOUsermanager.signinRedirect(
            {
              extraQueryParams: {
                login_hint: environmentVariables.ADMIN_MCD_LOGIN_HINT
              },
            }
          ).catch(e =>
            toasts.error(
              'Login failed. This is likely a configuration problem, please contact support.'
            )
          );
        } else {
          return this.honSSOUsermanager.signinRedirect().catch(e =>
            toasts.error(
              'Login failed. This is likely a configuration problem, please contact support.'
            )
          );;
        }
        //this.userManager.signinRedirect();
      }
    });

    this.honForgeUserManager.events.addUserLoaded(() => {
      this.honForgeUserManager.clearStaleState();
    });

    this.honSSOUsermanager.events.addUserLoaded(() => {
      this.honSSOUsermanager.clearStaleState();
    });
    if(!isHonSSOLogin){
      this.startSessionTimer();
    }

  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }
  public resetSessionTimer = () => {
    this.sessionTimer = 3600;
    this.lastActiveTime = new Date().getTime();
  };
  public startSessionTimer = () => {
    let sessionInterval = setInterval(() => {
      let currentDate = new Date();
      let currentTime: number = currentDate.getTime();
      let diff: number = (currentTime-this.lastActiveTime)/1000;
	  
      if (diff > this.sessionTimer) {
        clearInterval(sessionInterval);
        if (!window.location.href.includes('signup')) {
          sessionStorage.setItem('POST_SIGNIN_LOCATION', window.location.href);
          // Only redirect if you're not at any of the signup urls
          const environmentVariables = (window as any).ENV;
          if (isMCDSSO) {
                  return this.honForgeUserManager.signinRedirect(
                    {
                      extraQueryParams: {
                        login_hint: environmentVariables.ADMIN_MCD_LOGIN_HINT
                      },
                    }
                  ).catch(e =>
                    toasts.error(
                      'Login failed. This is likely a configuration problem, please contact support.'
                    )
                  );
                } else {
                  return this.honForgeUserManager.signinRedirect().catch(e =>
                    toasts.error(
                      'Login failed. This is likely a configuration problem, please contact support.'
                    )
                  );
                }
        }
      }
    }, 1000);
  };
  public authFetch = async (
    input: RequestInfo,
    init?: RequestInit | undefined
  ): Promise<Response> => {
    const user = await this.getUser();
    if (user) {
      const authHeaders = new Headers(
        init && init.headers ? init.headers : undefined
      );
      authHeaders.append('Authorization', `Bearer ${user.access_token}`);
      authHeaders.append('X-SVCorId', uuid4());
      return fetch(input, {
        ...init,
        headers: authHeaders
      });
    } else {
      return Promise.reject(new Error('No user found'));
    }
  };

  public fetchNodePermissions = (orgId: string, nodeId: string) => {
    return this.authFetch(
      `${this.BASE_URL}/api/v1/users/orgs/${orgId}/nodes/${nodeId}/privileges`
    );
  };

  public getOrgPermFetchURL = (orgId?: string) => {
    return `${this.BASE_URL}/api/v1/users/orgs/${orgId}/nodes/${orgId}/privileges?scopes=OrgManagement`;
  };

  public getOrgExportPermFetchURL = (orgId?: string): string => {
    return `${this.BASE_URL}/api/v1/users/orgs/${orgId}/can-update-orghierarchy`;
  }

  public getSitePermFetchURL = (orgId: string, siteId: string) => {
    return `${this.BASE_URL}/api/v1/users/orgs/${orgId}/nodes/${siteId}/privileges?scopes=ModelManagement`;
  };

  public getUserManagementPermFetchURL = (orgId?: string) => {
    return `${this.BASE_URL}/api/v1/users/me/orgs/${orgId}/privileges?scopes=UserManagement`;
  };

  public checkGlobalPermissionsCached = (userName: string | undefined) => {
    return !!sessionStorage.getItem(`globalPermissions:${userName}`);
  };

  public getSubscriptionPermFetchURL = (orgId?: string) => {
    return `${this.BASE_URL}/api/v1/users/orgs/${orgId}/nodes/${orgId}/privileges?scopes=SubscriptionManagement`;
  };

  /**
   * Fetches user privileges from the user-all-privileges API for a given scope
   * @param scope - The scope to fetch privileges for (e.g., 'LicenseManagement', 'Integration')
   * @returns Promise<IPermission[]> - Array of permissions or empty array on error
   */
  public fetchUserAllPrivileges = async (scope: string): Promise<IPermission[]> => {
    const apiUrl = `${this.BASE_URL}/api/v1/users/me/user-all-privileges?scopes=${scope}`;
    try {
      const response = await this.authFetch(apiUrl, { method: 'GET' });
      if (response.status === 200) {
        const privileges = await response.json();
        return privileges as IPermission[];
      } else {
        return [];
      }
    } catch (error) {
      console.error(`${scope} user-all-privileges: Error`, error);
      return [];
    }
  };

  public setGlobalPermissionsFromCached = (userName: string | undefined) => {
    // Check the session storage for cached permissions.
    // These permissions are frontend only to aid UX, no security aspect, so storing them on sessionStorage is ok.
    if (userName) {
      const cachedGlobalPerms = sessionStorage.getItem(
        `globalPermissions:${userName}`
      );
      this.globalPermissions = JSON.parse(
        cachedGlobalPerms ? cachedGlobalPerms : '[]'
      );
      // console.log('Global Perms cached: ', this.globalPermissions);
      return !!cachedGlobalPerms;
    } else {
      return false;
    }
  };

  // Checks the given list of permissions for a matching perm name, or list of perm names.
  // Also checks global permissions list first, and combines the two as global > local permission.
  public hasPermission = (permissions: IPermission[] | null, query: string) => {
    const checkPerm = (perm: IPermission) => {
      return perm.name === query;
    };

    return (
      (permissions ? !!permissions.find(checkPerm) : false) ||
      !!this.globalPermissions.find(checkPerm)
    );
  };

  public setGlobalPermissions = (userName: string | undefined) => {
    // Fetch permissions even if some cached, and then update with new, and write into sessionStorage.
    return this.authFetch(
      `${this.BASE_URL}/api/v1/users/me/privileges?scopes=UserManagement&scopes=OrgManagement&scopes=SubscriptionManagement&scopes=AssetModeling&scopes=ServiceAccountManagement`
    )
      .then(res => {
        if (res.ok) {
          return res.json();
        } else throw Error(res.statusText);
      })
      .then(res => {
        this.globalPermissions = res;
        if (userName) {
          sessionStorage.setItem(
            `globalPermissions:${userName}`,
            JSON.stringify(res)
          );
        }
        // console.log('Global perms: ', res);
      });
  };

  /**
   * Use this to check if the user has any given global permission
   */
  public hasGlobalPermission = (queryPermission: string) => {
    return !!this.globalPermissions.find(
      permission => permission.name === queryPermission
    );
  };

  public login = (prompt?:string): Promise<void> => {
    const environmentVariables = (window as any).ENV;

    if (isMCDSSO) {
      return this.userManager.signinRedirect(
        {
          extraQueryParams: {
            login_hint: environmentVariables.ADMIN_MCD_LOGIN_HINT
          },
        }
      ).catch(e =>
        toasts.error(
          'Login failed. This is likely a configuration problem, please contact support.'
        )
      );
    } else {
     let extraParams = {};
     prompt ? extraParams = { prompt: prompt } : extraParams = {};
     return this.userManager
       .signinRedirect({
         extraQueryParams: extraParams
       })
       .catch(e =>
         toasts.error(
           'Login failed. This is likely a configuration problem, please contact support.'
         )
       );
    }
    // return this.userManager
    //   .signinRedirect()
    // .catch(e =>
    //   toasts.error(
    //     'Login failed. This is likely a configuration problem, please contact support.'
    //   )
    // );
  };

  public renewToken(): Promise<User> {
    return this.userManager.signinSilent();
  }

  public logout = () => {
    // console.log('Logging out');
    this.getUser().then(user => {
      if (user) {
        sessionStorage.setItem('POST_SIGNIN_LOCATION', window.location.href);
        // Session storage used for global perms to not block UI, updated after load.
        // Cleared between sessions
        sessionStorage.removeItem(
          `globalPermissions:${user.profile.preferred_username}`
        );
        sessionStorage.removeItem('NEW_SUBSCRIPTION_NOTIFICATION');

        this.userManager.signoutRedirect();
      }
    });
  };

  public checkLicensesPrivilege = async (userEmail: string | undefined, userId: string | undefined, siOrgId: string): Promise<boolean> => {
    if ((!userEmail && !userId) || !siOrgId) {
      this.isLicensePrivilegedUser = false;
      return false;
    }

    const apiUrl = `${this.BASE_URL}/api/v1/orgs/${siOrgId}/licenses/privileged-users`;
    try {
      const response = await this.authFetch(apiUrl, { method: 'GET' });
      if (response.status === 200) {
        const result = await response.json();
        const users: string[] = result.data || [];
        this.isLicensePrivilegedUser = users.some(
          (entry: string) => {
            const entryLower = entry.toLowerCase();
            return (userEmail && entryLower === userEmail.toLowerCase()) ||
                   (userId && entryLower === userId.toLowerCase());
          }
        );
        return this.isLicensePrivilegedUser;
      }
      this.isLicensePrivilegedUser = false;
      return false;
    } catch (error) {
      console.error('checkLicensesPrivilege: Error', error);
      this.isLicensePrivilegedUser = false;
      return false;
    }
  };
}

export default new AuthService(isMCDSSO ? (window as any).ENV.AUTHORITY_CLIENT_ID_MCD : (window as any).ENV.AUTHORITY_CLIENT_ID);
